<template>
	<div class="page-container bg-secondary my-card-registration-page full-width">
		<div class="no-cards-info" v-show="!hasCards">
			{{ $t('cards.noCardsAvailable') }}
		</div>

		<div class="register-new-card" v-show="hasCards">
			{{ $t('cards.buttons.registerNewCard') }}
		</div>

		<card-registration />
	</div>
</template>

<script>
	export default{
		name: 'MyCardPage',
		components: {
			CardRegistration: () => import('@/components/CardRegistration.vue'),
		},
		data () {
			return {}
		},
		computed: {
			hasCards () {
				return this.$store.state.cards.length >= 1
			}
		}
	}
</script>

<style lang="scss">
	.page-container.my-card-registration-page{
		padding-left: 1rem!important;
		padding-right: 1rem!important;
		padding-bottom: 0;
		position: relative;
		z-index: 1000;
		max-width: 100vw !important;

		.no-cards-info,
		.register-new-card{
			margin-bottom: 3rem;
			text-align: center;
			font-size: 1.5rem;
			font-weight: bold;
		}
	}
</style>
